export interface FreeShippingCarrierOption {
  id: number;
  label: string;
}

export const FREE_SHIPPING_CARRIERS: FreeShippingCarrierOption[] = [
  { id: 4, label: "Colissimo / La Poste" },
  { id: 10, label: "DPD" },
  { id: 14, label: "GLS" },
  { id: 19, label: "UPS" },
  { id: 2729, label: "Chronopost" },
  { id: 2733, label: "DHL" },
  { id: 2748, label: "FedEx" },
  { id: 6, label: "GPX" },
];

export function normalizeTrackingNumber(value: string): string {
  return value.replace(/\s+/g, "").toUpperCase();
}

export function detectFreeShippingCarrier(value: string): number | null {
  const tracking = normalizeTrackingNumber(value);
  if (/^1Z[0-9A-Z]{16}$/.test(tracking)) return 19;
  if (/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(tracking)) return 2729;
  if (/^\d{14}$/.test(tracking)) return 10;
  if (/^\d{12}(?:\d{3})?$/.test(tracking)) return 2748;
  if (/^\d{10}$/.test(tracking)) return 2733;
  if (/^[0-9][A-Z]\d{9,12}$/.test(tracking)) return 4;
  return null;
}
